import './template.css';
import { useState } from 'react';
import { AxiosError } from 'axios';
import '../../rxlib/style/rxlib.css';
import api from '../../services/aut';
import logo from '../../images/naja.png';
import { Redirect } from 'react-router-dom';
import '../../rxlib/style/responsividade.css';
import { useForm, SubmitHandler } from 'react-hook-form';
import { obterVersao } from '../../services/utilitarios';
import Button from '../../rxlib/components/buttons/button';
import { tokenExpirado } from '../../rxlib/services/seguranca';
import { useAppSelector, useAppDispatch } from '../../store/hooks';
import { AcessoProps, ApiError, FormLogin } from '../../services/tipos';
import { ModalWarning } from '../../rxlib/components/modal/modal-warning';
import { criptografar, obterAmbiente, tratarErroApi } from '../../rxlib/services/utilitarios';

function Login(props: AcessoProps) {
    const [acao, setAcao] = useState(props.match.params.acao);
    const [carregando, setCarregando] = useState<boolean>(false);
    const [showWarning, setShowWarning] = useState<boolean>(false);
    const [messageWarning, setMessageWarning] = useState<string[]>([]);
    const [token, setToken] = useState<string>(useAppSelector(state => state.token));
    const [logado, setLogado] = useState<boolean>(useAppSelector(state => state.logado));
    const [expirado, setExpirado] = useState<boolean>(useAppSelector(state => state.expirado));

    const { register, handleSubmit } = useForm<FormLogin>();

    const dispatch = useAppDispatch();

    const handleHide = () => setShowWarning(false);

    const onSubmit: SubmitHandler<FormLogin> = data => {
        setCarregando(true);
        data.senha = criptografar(data.email + data.senha);
        api.post('/Login/AutenticarCle', data)
            .then(response => {
                setTimeout(() => {
                    dispatch({
                        type: 'LOG_IN',
                        token: response.data.token,
                    });
                    setToken(response.data.token);
                    setLogado(true);
                }, 250);
            }).catch((error: AxiosError<ApiError>) => {
                tratarErro(error);
            });
    }

    function tratarErro(error: AxiosError<ApiError>) {
        setCarregando(false);
        setMessageWarning(tratarErroApi(error, 'Não foi possível realizar o login: '));
        setShowWarning(true);
    }

    function showSecaoExpirada() {
        setMessageWarning(['A seção do usuário expirou.', 'Realize o login novamente.']);
        setShowWarning(true);
        setExpirado(false);
    }

    function showAcessoBloqueado() {
        setMessageWarning(['O acesso foi bloqueado pois o usuário não esta logado.']);
        setShowWarning(true);
        setAcao('');
    }

    return (
        <>
            {
                !tokenExpirado(token)
                    ? logado
                        ? <Redirect to='/home' />
                        : ''
                    : ''
            }
            {
                expirado
                    ? showSecaoExpirada()
                    : ''
            }
            {
                acao === 'acessobloqueado'
                    ? showAcessoBloqueado()
                    : ''
            }
            <div className='login-content d-flex align-items-center'>
                <form className='form-signin mx-auto rxlib-login-retangulo' onSubmit={handleSubmit(onSubmit)}>
                    <div className='text-center rxlib-conteiner-logo'>
                        <img className='mb-5 mt-2 rxlib-logo-retangulo' src={logo} alt='Naja' />
                    </div>
                    <div className='form-label-group'>
                        <input ref={register({ required: true })} name='email' type='email' id='inputEmail' className='form-control' placeholder='Endereço de e-mail' required autoFocus />
                        <label htmlFor='inputEmail'>Endereço de e-mail</label>
                    </div>
                    <div className='form-label-group'>
                        <input ref={register({ required: true })} name='senha' type='password' id='inputPassword' className='form-control' placeholder='Senha' required />
                        <label htmlFor='inputPassword'>Senha</label>
                    </div>
                    <div className='d-grid align-middle'>
                        <Button
                            type='submit'
                            texto='Entrar'
                            className='btn-lg'
                            classStyle='btn-rxlib'
                            carregando={carregando}
                            classNameDivSpinner='login-spinner-button' />
                    </div>
                    <p className='mt-5 mb-2 text-muted text-center'>
                        © 2026 {obterVersao()}
                        <span className='rxlib-homologacao'>
                            {obterAmbiente()}
                        </span>
                    </p>
                </form>
            </div>
            <ModalWarning
                show={showWarning}
                onHide={handleHide}
                message={messageWarning} />
        </>
    );
}

export default Login;